<template>
  <div>
    <h2>{{ isEdit ? 'Modification' : 'Ajout' }} de client</h2>

    <div class="row">
      <div class="mb-3 col bg-light border rounded p-3">
        <label for="telephone_client" class="form-label fw-bold">Téléphone*</label>
        <input type="text" class="form-control" id="telephone_client" placeholder="Téléphone du client"
          v-model="formData.telephone" required>
        <small class="text-danger" v-if="errors['telephone']">{{ errors['telephone'][0] }}</small>

      </div>
    </div>
    <div class="row">
      <div class="mb-3 col-md-6">
        <label for="nom_client" class="form-label fw-bold">Nom*</label>
        <input type="text" class="form-control" id="nom_client" placeholder="Nom du client" v-model="formData.nom"
          required>
        <small class="text-danger" v-if="errors['nom']">{{ errors['nom'][0] }}</small>

      </div>

      <div class="mb-3 col-md-6">
        <label for="prenoms_client" class="form-label">Prénoms</label>
        <input type="text" class="form-control" id="prenoms_client" placeholder="Prénoms du client"
          v-model="formData.prenoms">
        <small class="text-danger" v-if="errors['prenoms']">{{ errors['prenoms'][0] }}</small>
      </div>



      <div class="mb-3 col-md-6">
        <label for="adresse_client" class="form-label">Adresse</label>
        <input type="text" class="form-control" id="adresse_client" placeholder="Adresse du client"
          v-model="formData.adresse">
      </div>

      <div class="mb-3 col-md-6">
        <label for="genre_client" class="form-label fw-bold">Genre*</label>

        <select class="form-select" v-model="formData.genre" required>
          <option value="" selected disabled>-- Sélectionner le genre --</option>
          <option value="M">Homme</option>
          <option value="F">Femme</option>
        </select>
        <small class="text-danger" v-if="errors['genre']">{{ errors['genre'][0] }}</small>

      </div>

      <div class="mb-3 col-md-6 d-none">
        <label for="taile_client" class="form-label fw-bold">Taille</label>

        <select class="form-select" v-model="formData.body_size">
          <option value="S">Petite (S)</option>
          <option value="M" selected="">Moyenne (M)</option>
          <option value="L">Grande (L)</option>
          <option value="XL">Plus grande (XL)</option>
          <option value="XL">Très grande (XXL)</option>
        </select>
        <small class="text-danger" v-if="errors['body_size']">{{ errors['body_size'][0] }}</small>

      </div>


      <div class="row mt-2">
        <div class="col text-end">
          <button v-if="showCancelButton" type="button" class="btn btn-warning mx-2" @click="removeClientInfo"><i
              class="bi bi-x-circle me-1"></i>Vider</button>
          <button class="btn btn-success" @click="saveInfo"><i class="bi bi-check-circle me-1"></i>Valider</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';
import { cartStore } from '@/store/cartStore';

export default {
  name: 'ClientForm',
  mixins: [formMixin],
  emits: ['client-info-saved', 'client-info-removed'],
  props: {
    tenant_id: {
      type: String,
      required: true,
    },
    catalog_id: {
      type: [Number, String],
      required: true,
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    saveInfoTrigger: {
      type: Number,
    },
  },
  data() {
    return {
      defaultData: {
        genre: 'M',
      },
      url: '/clients',
      potentialClientInfo: null,
    };
  },
  computed: {
    cartStore() {
      return cartStore();
    },
    isValid() {
      return this.formData.nom && this.formData.telephone && this.formData.genre;
    },
  },
  watch: {
    saveInfoTrigger() {

      this.saveInfo();
      console.log('saveInfo called from watcher, current formData:', this.formData);

    },
    "formData.telephone": {
      handler(newVal) {
        if (newVal && newVal.length >= 10) {
          this.getPotentialClientInfo(newVal);
          console.log('Fetching potential client info for telephone:', newVal);
          // this.formData.telephone = newVal.replace(/\D/g, '');
        }
      },
      deep: true
    }

    // saveInfoTrigger:{
    //   handler(newVal) {
    //     console.log('saveInfoTrigger changed:', newVal);
    //     if (newVal > 0) {
    //       this.saveInfo();
    //       console.log('saveInfo called from watcher, current formData:', this.formData);
    //     }
    //   },
    //   immediate: true
    // }
  },
  methods: {
    saveInfo() {
      if (this.isValid) {
        this.cartStore.setCustomerInfo(this.formData);
        this.$emit('client-info-saved', this.formData);
      }
    },
    removeClientInfo() {
      this.cartStore.removeCustomerInfo();
      this.formData = { ...this.defaultData };
      this.$emit('client-info-removed');
    },
    getPotentialClientInfo(telephone) {

      // Fetch potential client info based on the telephone number
      if (this.potentialClientInfo == null
        || Object.keys(this.potentialClientInfo).length === 0
        || this.potentialClientInfo.telephone !== telephone
      ) {
        this.$api.get(`/clients/get-info/${telephone}`)
          .then(response => {
            if (response.data && Object.keys(response.data).length > 0) {
              this.potentialClientInfo = { ...response.data.data };

              this.formData.nom = this.potentialClientInfo.nom || ''
              this.formData.prenoms = this.potentialClientInfo.prenoms || ''
              this.formData.adresse = this.potentialClientInfo.adresse || ''
              this.formData.genre = this.potentialClientInfo.genre || 'M'
            }
          })
          .catch(() => {
            this.potentialClientInfo = null;
            this.formData.nom = null
            this.formData.prenoms = null
            this.formData.adresse = null
            this.formData.genre = this.defaultData.genre || 'M'
          });
      }
    },
  },
  mounted() {
    // Load existing client info from cart store if available
    const existingInfo = this.cartStore.customerInfo;
    if (existingInfo && Object.keys(existingInfo).length > 0) {
      this.formData = { ...this.defaultData, ...existingInfo };
    } else {
      this.formData = { ...this.defaultData };
    }
  },
};
</script>

<style scoped>
form div {
  margin-bottom: 8px;
}
</style>
